<template>
    <div class="client-attendance">
        <div @click="$modal.show(`sa_${table.id}_${client.id}`)" :class="`attendance type_${attendance}`"></div>
        <set-attendance v-model="attendance" :table="table" :client="client" :modal="`sa_${table.id}_${client.id}`" />
    </div>
</template>

<script>
import SetAttendance from './SetAttendance.vue';
export default {
    created() {
        for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id == this.table.id) {
                this.attendance = this.value[i].pivot.status;
            }
        }
    },
    data() {
        return {
            attendance: null
        };
    },
    props: ["client", "value", "table"],

    components: { SetAttendance }
};
</script>

<style lang="scss">
.client-attendance {
    position: relative;
    overflow: visible;
}

.attendance {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    padding: 0;
    margin: 0;
    width: 18px;
    height: 18px;
    max-width: 18px;
    max-height: 18px;
    min-width: 18px;
    min-height: 18px;
    border: 1px solid #999;
    text-align: center;
    color: #111;
    &.type_null {
        background: #fff;
    }
    &.type_0 {
        background: green;
    }
    &.type_1 {
        background: red;
    }
    &.type_2 {
        background: blue;
    }
    &.type_3 {
        background: yellow;
    }
}
</style>

